










import Contact from "@/models/contact";
import ContactAPI from "@/services/contacts";
import { LayoutModule } from "@/store/layout";
import { Component, Vue } from "vue-property-decorator";
import ContactForm from "./Components/ContactForm.vue";

@Component({
  components: {
    ContactForm,
  },
})
export default class EditContact extends Vue {
  contact: Contact | null = null;
  loading = true;

  created(): void {
    if (this.$route.params.id) this.getContact();
  }

  async getContact(): Promise<void> {
    LayoutModule.showLoader();

    try {
      const r = await ContactAPI.getContact(
        this.$route.params.id,
        this.$route.params.companyId
      );
      this.contact = r;
      this.contact.company_id = this.$route.params.companyId;
    } catch (e) {
      console.log(e);
    } finally {
      LayoutModule.hideLoader();
    }
    this.loading = false;
  }

  async save(contact: Contact): Promise<void> {
    LayoutModule.showLoader();
    try {
      await ContactAPI.updateContact(contact);
      LayoutModule.setAlerts({
        text: this.$t("contacts.responses.success_update").toString(),
        type: "success",
      });
    } catch (e) {
      console.log(e);
    }
    LayoutModule.hideLoader();
  }
  cancel(): void {
    this.$router.push({ name: "contacts" });
  }
}
